export {onRenderClient};

import {hydrate, render} from 'preact';
import {HelmetProvider} from 'react-helmet-async';
import {PageShell} from '../PageShell.jsx';
import {initSentry} from '../lib/sentry.js';

initSentry();

let firstRender = true;

async function onRenderClient(pageContext) {
    const {Page, data} = pageContext;

    if (data?.tenant) {
        window.__SITE_CONFIG__ = data.tenant.messages;
        window.__SITE_FAQ__ = data.tenant.faq;
        window.__SITE_ABOUT__ = data.tenant.about;
    }

    const container = document.getElementById('app-root');

    const tree = (
        <HelmetProvider>
            <PageShell pageContext={pageContext}>
                <Page/>
            </PageShell>
        </HelmetProvider>
    );

    if (firstRender) {
        hydrate(tree, container);
        firstRender = false;
    } else {
        render(tree, container);
    }
}
